import type { UiMessages } from "../types";

export const it: UiMessages = {
  nav: {
    streams: "Dirette",
    videos: "Video",
    shorts: "Shorts",
    forYou: "Per te",
    vr: "VR",
    cartoon: "Cartoni",
    hentai: "Hentai",
    sections: "Altro",
    menu: "Menu",
    game: "Gioco porno",
    stories: "Racconti erotici",
    escorts: "Escort",
    ai: "Fidanzate IA",
    paysites: "Siti premium",
    home: "Home",
    following: "Seguiti",
    watching: "In visione",
    rankings: "Classifiche",
    invite: "Invita amici",
    coins: "Sweet Coin",
    achievements: "Traguardi",
    hot: "Ora di tendenza",
    random: "Video a caso",
    saved: "Salvati",
    reacted: "Reazioni",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Pornostar",
    productions: "Produzioni",
    categories: "Categorie",
    telegram: "Canale Telegram",
    allSections: "Tutte le sezioni",
    mainNavigation: "Navigazione principale",
    quickNavigation: "Navigazione rapida",
    show: "Mostra",
    coinsReady: "Sweet Coin da riscuotere",
    logIn: "Accedi",
    search: "Cerca",
    closeSearch: "Chiudi ricerca",
    language: "Lingua",
    theme: "Tema",
    themeDark: "Scuro",
    themeLight: "Chiaro",
  },
  age: {
    parents: "Genitori: la nostra pagina {link} spiega come bloccare l’accesso a questo sito. Sweet è contrassegnato con l’etichetta RTA.",
    parentalControls: "controllo parentale",
    title: "Questo è un sito per adulti",
    body: "Questo sito contiene materiale vietato ai minori, tra cui nudità e rappresentazioni esplicite di attività sessuali. Entrando confermi di avere almeno 18 anni, o la maggiore età prevista nel Paese da cui accedi al sito, e di acconsentire alla visione di contenuti sessualmente espliciti.",
    enter: "Ho 18 anni o più — Entra",
    exit: "Ho meno di 18 anni — Esci",
  },
  consent: {
    title: "Cookie",
    body: "Sweet è gratis grazie alla pubblicità. I nostri partner pubblicitari usano i cookie per mostrare gli annunci e contarne visualizzazioni e clic. L’archiviazione necessaria, come la conferma della tua età, funziona in ogni caso.",
    privacy: "Informativa sulla privacy",
    acceptAll: "Accetta tutto",
    onlyNecessary: "Solo necessari",
    settings: "Impostazioni cookie",
  },
  ago: { now: "ora", m: "{n} min", h: "{n} h", d: "{n} g", w: "{n} sett.", mo: "{n} mes.", y: "{n} a." },
  cams: {
    allPlatforms: "Tutte le piattaforme",
    watchOnSite: "Guarda su {site}",
    liveFor: "in diretta da {time}",
    tryAnother: "Prova un altro tag o un’altra regione, oppure torna tra poco.",
    nobodyLiveOn: "Nessuno è in diretta su {name} in questo momento",
    platformShowUpHint: "Le dirette di {name} compaiono qui appena iniziano. Torna tra poco.",
    liveNowCount: "{n} in diretta ora",
    opensOn: "si aprono su {site}",
    streamerSite: "il sito della diretta",
    orWatch: "Oppure guarda {link}.",
    videoTag: "i video #{tag}",
    liveStreams: "Dirette live",
    platformStreams: "Dirette su {name}",
    liveCams: "Cam dal vivo",
    platformCams: "Cam di {name}",
    moreLiveCams: "Altre cam dal vivo",
    byTopic: "Cam dal vivo per tema",
    breadcrumb: "Percorso di navigazione",
    live: "Live",
    viewers: "Spettatori:",
    isLive: "{name} è in diretta",
    watchOn: "{title} — guarda in diretta su {site}",
    nobodyLive: "Nessuno è in diretta ora",
    noMatch: "Nessuna diretta corrisponde a questi filtri",
    showUpHint: "Le dirette compaiono qui appena iniziano. Ricontrolla tra poco.",
    clearFilters: "Cancella filtri",
    clearAll: "Cancella tutto",
    clear: "Cancella",
    seeAllPlatforms: "Vedi tutte le piattaforme",
    watchVideos: "Guarda i video",
    onPlatform: " su {name}",
    newOnTelegram: "Nuove cam dal vivo su Telegram",
    loadMoreFailed: "Impossibile caricarne altri — riprova",
    platforms: "Piattaforme",
    streamPlatforms: "Piattaforme di streaming",
    platformsAndFilters: "Piattaforme di streaming e filtri",
    categories: "Categorie",
    all: "Tutti",
    region: "Regione",
    allRegions: "Tutte le regioni",
    more: "Altro",
    newModels: "Nuove modelle",
    tags: "Tag",
    removeTag: "Rimuovi tag",
    remove: "Rimuovi",
    loading: "Caricamento",
    offline: "Offline",
    seeAll: "Vedi tutto",
    genders: { female: "Donne", male: "Uomini", couple: "Coppie", trans: "Trans" },
    regions: { north_america: "Nordamericane", south_america: "Sudamericane", europe: "Europee e russe", asia: "Asiatiche", other: "Altre regioni" },
  },
  video: {
    fullScene: "Guarda la scena completa su {site}",
    upNext: "A seguire",
    nextPage: "Pagina successiva",
    moreVideos: "Altri video",
    end: "Hai raggiunto la fine.",
    loadMoreFailed: "Impossibile caricarne altri — riprova",
    likes: "Mi piace",
    premiumVideo: "Video Premium",
    subscribeToWatch: "Abbonati per guardare questo video per intero.",
    getPremium: "Passa a Premium",
    logIn: "Accedi",
    playsIn: "Riprodotto nel player di {name}",
    partnerBlocked: "Il video viene riprodotto dai server di {name}, che non si raggiungono dalla tua rete: {name} potrebbe essere bloccato dal tuo provider o nel tuo paese.",
    unavailable: "{name} non riproduce i suoi video nel tuo Paese, quindi questo non si può guardare qui.",
    watchCams: "Guarda invece le cam dal vivo",
    chatLive: "Chatta dal vivo con {name} su {site}",
    play: "Riproduci {title}",
    sponsored: "Sponsorizzato",
    onlyfansCreators: "Creator di OnlyFans",
    liveNowFree: "In diretta ora · gratis",
    allVideos: "Tutti i video",
    stoppedAt: "Interrotto a {at} di {of}",
    watchedToEnd: "Visto fino alla fine",
  },
  profile: { followers: "Follower", views: "Visualizzazioni", videos: "Video", verified: "Verificato", follow: "Segui", unfollow: "Non seguire più" },
  lists: {
    categories: "Categorie",
    popular: "Popolari",
    aToZ: "A – Z",
    jumpToLetter: "Vai alla lettera",
    allCategories: "Tutte le categorie",
    noVideosYet: "Ancora nessun video qui",
    pageN: "Pagina {n}",
    newEveryDay: "Nuovi video ogni giorno.",
    videoCount: "{n} video",
    pornstars: "Pornostar",
    pornstarsIntro: "I creator più seguiti della settimana.",
    studios: "Studi porno",
    studiosIntro: "Case di produzione e canali, in ordine di follower.",
    noVideosWithTag: "Nessun video con questo tag",
    showAllVideos: "Mostra tutti i video",
  },
  hot: {
    title: "Ora di tendenza",
    intro: "I video più guardati su Sweet nelle ultime ore.",
  },
  comments: {
    title: "Commenti",
    placeholder: "Scrivi un commento…",
    post: "Pubblica",
    login: "Accedi per commentare",
    coinsHint: "+{n} monete per ciascuno dei tuoi primi {max} commenti del giorno",
    earned: "+{n} monete",
    empty: "Ancora nessun commento. Sii il primo.",
    more: "Mostra altri",
    delete: "Elimina",
    short: "Scrivi qualcosa in più.",
    long: "Troppo lungo: massimo {n} caratteri.",
    links: "Link e contatti non sono ammessi nei commenti.",
    forbidden: "Questo commento non può essere pubblicato.",
    rate: "Stai commentando troppo in fretta. Riprova più tardi.",
    duplicate: "Hai già pubblicato questo.",
    failed: "Impossibile pubblicare. Riprova.",
    like: "Mi piace",
    dislike: "Non mi piace",
    rateLogin: "Accedi per valutare i video",
    liked: "Piace al {p}%",
  },
  starVote: {
    title: "Star del mese",
    vote: "Vota",
    voteFor: "Vota {name} come star del mese",
    voteAgain: "Vota ancora · {n} monete",
    confirm: "Spendere {n} monete?",
    standing: "N. {rank} questo mese · voti: {n}",
    noVotes: "Ancora nessun voto questo mese",
    thanks: "Grazie per il tuo voto!",
    paidThanks: "Voto contato · −{n} monete",
    coins: "Monete insufficienti: un voto costa {n}.",
    limit: "Hai usato tutti i voti di oggi.",
    rules: "Un voto gratis al giorno, poi {n} monete a voto.",
    boardIntro: "I membri votano le loro star preferite nelle loro pagine: un voto gratis al giorno, altri per {n} monete ciascuno.",
    boardEmpty: "Ancora nessun voto questo mese. Vota una star nella sua pagina.",
    votes: "Voti",
    lastWinner: "Star del mese scorso",
    login: "Accedi per votare",
  },
  achievements: {
    title: "Traguardi",
    intro: "Sblocca traguardi mentre guardi, segui e partecipi. Ognuno dà Sweet Coins.",
    unlocked: "Sbloccato",
    coins: "+{n} monete",
    progress: "{x} di {n}",
    total: "{x} di {n} sbloccati",
    login: "Accedi per ottenere i traguardi e le loro monete.",
    signup: "Crea un account",
    toast: "Traguardo sbloccato",
    names: {
      "videos-1": ["Primo video", "Guarda il tuo primo video"],
      "videos-10": ["Riscaldamento", "Guarda 10 video"],
      "videos-100": ["Abituale", "Guarda 100 video"],
      "videos-1000": ["Intenditore", "Guarda 1.000 video"],
      "hours-1": ["Un'ora", "Guarda per un'ora"],
      "hours-10": ["Dieci ore", "Guarda per 10 ore"],
      "hours-100": ["Maratona", "Guarda per 100 ore"],
      "streak-3": ["Tre di fila", "Guarda per 3 giorni di fila"],
      "streak-7": ["Serie di una settimana", "Guarda ogni giorno per una settimana"],
      "streak-30": ["Serie di un mese", "Guarda ogni giorno per 30 giorni"],
      "follows-5": ["Fan", "Segui 5 star o case di produzione"],
      "likes-25": ["Gran cuore", "Metti mi piace a 25 video"],
      "saves-10": ["Collezionista", "Salva 10 video"],
      "days-7": ["Settimana di monete", "Raccogli monete per 7 giorni"],
      "days-30": ["Mese di monete", "Raccogli monete per 30 giorni"],
      "invites-1": ["Porta un amico", "Invita un amico che si registra"],
      "comments-1": ["Prime parole", "Scrivi il tuo primo commento"],
      "comments-25": ["Chiacchierone", "Scrivi 25 commenti"],
      "votes-1": ["Elettore", "Vota la star del mese"],
    },
  },
  pwa: {
    appName: "App Sweet",
    bannerLabel: "Installa l'app",
    bannerPitch: "Schermo intero, senza app store",
    install: "Installa",
    notNow: "Non ora",
    installApp: "Installa l'app",
    howToInstall: "Come installarla",
    inApp: "Stai usando l'app.",
    cardPitch: "Schermo intero, a un tocco dalla schermata Home. Nessun app store.",
    manual: "Apri il menu del browser e scegli {install} o {add}.",
    iosTitle: "Aggiungi Sweet alla schermata Home",
    iosShare: "Tocca {share} nella barra del browser (su iOS 26: {more}, poi {share})",
    iosAdd: "Scegli {add}",
    iosConfirm: "Tocca {confirm}: Sweet si apre a schermo intero dalla schermata Home",
    share: "Condividi",
    more: "•••",
    add: "Aggiungi alla schermata Home",
    confirm: "Aggiungi",
    installMenu: "Installa app",
    gotIt: "Ho capito",
    close: "Chiudi",
    offlineTitle: "Sei offline",
    offlineBody: "Sweet ha bisogno di internet per i video e le cam. Controlla la connessione e riprova.",
    retry: "Riprova",
    recent: "Aperte di recente",
  },
  notifications: {
    title: "Notifiche",
    empty: "Ancora nessuna novità. Segui star e case di produzione, o aggiungi modelle in cam ai preferiti, e qui troverai le loro novità.",
    newVideos: "Nuovi video",
    liveNow: "In diretta ora",
    markRead: "Segna tutto come letto",
    pushOn: "Attiva le notifiche",
    pushOff: "Disattiva le notifiche",
    pushHint: "Ricevi un avviso per i nuovi video e i preferiti in diretta, anche con Sweet chiuso.",
    pushBlocked: "Le notifiche di Sweet sono bloccate nelle impostazioni del browser.",
    pushUnsupported: "Questo browser non può mostrare notifiche. Su iPhone, aggiungi prima Sweet alla schermata Home.",
    pushEnabled: "Notifiche attive",
    favorites: "Modelle preferite",
    addFavorite: "Aggiungi ai preferiti",
    removeFavorite: "Rimuovi dai preferiti",
    favoritesEmpty: "Ancora nessuna modella preferita. Tocca il cuore su una cam per aggiungerla.",
    offline: "Offline",
    viewAll: "Vedi tutto",
  },
  forYou: {
    title: "Per te",
    all: "Tutti",
    continueWatching: "Continua a guardare",
    intro: "Scelti in base a ciò che ti piace, salvi, guardi e segui.",
    empty: "Metti mi piace, salva o segui qualche video e star, e qui troverai video scelti per te.",
    more: "Altri",
  },
  shorts: {
    straight: "Etero",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Guarda il video completo",
    like: "Mi piace",
    liked: "Ti piace",
    save: "Salva",
    saved: "Salvato",
    share: "Condividi",
    copied: "Link copiato",
    soundOn: "Attiva l'audio",
    soundOff: "Disattiva l'audio",
    tapForSound: "Tocca per l'audio",
    report: "Segnala",
    follow: "Segui",
    following: "Segui già",
    previous: "Precedente",
    next: "Successivo",
    close: "Chiudi",
    end: "Per ora è tutto. Altri in Video.",
    empty: "Non ci sono ancora shorts qui.",
    live: "Live",
    watchLive: "Guarda live gratis",
    watching: "{n} spettatori",
    profile: "Profilo",
    moreLive: "Altre cam live",
  },
  search: {
    searches: "Ricerche",
    popular: "Ricerche popolari",
    categories: "Categorie",
    searchFor: "Cerca video per «{q}»",
    nothingFor: "Nessun risultato per «{q}».",
    title: "Cerca su Sweet",
    placeholder: "Cerca video, persone e brand",
    hint: "Trova video, star, produzioni e categorie. Premi / ovunque per iniziare a scrivere.",
    stars: "Star",
    productions: "Produzioni",
    other: "Altro",
    otherProfiles: "Altri profili",
    nothing: "Nessun risultato",
    tryAgain: "Controlla come hai scritto o prova un termine più generico.",
    backHome: "Torna alla home",
  },
  notFound: { title: "Questa pagina non esiste", body: "Il video potrebbe essere stato rimosso, oppure il link è sbagliato.", home: "Vai alla home" },
  common: {
    close: "Chiudi",
    copy: "Copia",
    copied: "Copiato",
    more: "Altro",
    loading: "Caricamento",
    clearAll: "Cancella tutto",
    browseVideos: "Guarda i video",
    scrollLeft: "Scorri a sinistra",
    scrollRight: "Scorri a destra",
  },
  actions: {
    react: "Mi piace",
    reacted: "Ti piace",
    save: "Salva",
    saved: "Salvato",
    follow: "Segui",
    following: "Segui già",
    followName: "Segui {name}",
    unfollowName: "Smetti di seguire {name}",
    moreOptions: "Altre opzioni",
    share: "Condividi",
    copyLink: "Copia link",
    linkCopied: "Link copiato",
    report: "Segnala",
    home: "Sweet — home",
    onSweet: "{name} su Sweet",
    joinMe: "Raggiungimi su Sweet",
    inviteLink: "Il tuo link d’invito",
  },
  library: {
    savedEmpty: "Ancora niente di salvato",
    savedHint: "Tocca il segnalibro sotto un video per tenerlo qui. La tua lista è salvata solo su questo dispositivo.",
    reactedEmpty: "Ancora nessuna reazione",
    reactedHint: "I video a cui metti il cuore compaiono qui, dai più recenti.",
    watchingEmpty: "Ancora niente di guardato",
    watchingHint: "I video che avvii compaiono qui con il momento esatto in cui ti sei fermato, e ripartono da lì quando li riapri.",
    removeWatching: "Rimuovi dalla cronologia",
    removeVideo: "Rimuovi {title} dalla cronologia",
    followingEmpty: "Non segui ancora nessuno",
    followingHint: "Tocca il + di una modella o di uno studio e i loro video più nuovi si raccoglieranno qui. I profili seguiti sono salvati solo su questo dispositivo.",
    discoverModels: "Scopri le modelle",
    noVideosHint: "Prova un’altra categoria: ogni giorno arrivano nuovi video.",
    backToAll: "Torna a tutti i video",
  },
  player: {
    resumesAt: "Riprende da {at}",
    startOver: "Ricomincia",
    unavailable: "Questo video al momento non è disponibile.",
    play: "Riproduci",
    pause: "Pausa",
    seek: "Cerca",
    back10: "Indietro di 10 secondi",
    forward10: "Avanti di 10 secondi",
    mute: "Disattiva audio",
    unmute: "Attiva audio",
    volume: "Volume",
    settings: "Impostazioni",
    pip: "Picture in picture",
    fullscreen: "Schermo intero",
    exitFullscreen: "Esci da schermo intero",
    quality: "Qualità",
    speed: "Velocità di riproduzione",
    normal: "Normale",
    auto: "Auto",
    partner: "il partner",
  },
  ads: { ad: "Pubblicità", advertisement: "Pubblicità", muteAd: "Disattiva audio della pubblicità", unmuteAd: "Attiva audio della pubblicità", skipIn: "Salta tra {n}", skipAd: "Salta pubblicità ›" },
  auth: {
    username: "Nome utente",
    usernameOrEmail: "Nome utente o email",
    emailOptional: "Email (facoltativa)",
    password: "Password",
    currentPassword: "Password attuale",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    confirmNewPassword: "Conferma nuova password",
    showPassword: "Mostra password",
    hidePassword: "Nascondi password",
    forgot: "Password dimenticata?",
    remember: "Resta connesso",
    logIn: "Accedi",
    createAccount: "Crea account",
    usernameHelp: "Da 3 a 24 lettere, numeri, punti o trattini bassi. Visibile nelle classifiche.",
    emailHelp: "Serve solo per reimpostare la password. Puoi aggiungerla più tardi nel tuo account.",
    passwordHelp: "Almeno 8 caratteri.",
    adult: "Ho 18 anni o più.",
    agree: "Accetto i {terms} e l’{privacy}.",
    terms: "Termini",
    privacy: "Informativa sulla privacy",
    savePhrasesTitle: "Salva le tue frasi di recupero",
    savePhrasesBody: "Ti sei registrato senza email, quindi queste frasi sono il modo per rientrare se dimentichi la password.",
    continue: "Continua",
    resetHow: "Come reimpostare la password",
    byEmail: "Inviami un link",
    byPhrase: "Usa una frase di recupero",
    phraseIntro: "Per gli account creati senza email: inserisci il tuo nome utente e una qualsiasi delle frasi di recupero salvate al momento della registrazione.",
    phrase: "Frase di recupero",
    phrasePlaceholder: "parola parola parola parola",
    phraseHelp: "Le 4 parole di una frase. Ogni frase funziona una sola volta.",
    saveNewPassword: "Salva la nuova password",
    sendLink: "Invia link di reimpostazione",
  },
  phrases: {
    warning: "Salvale adesso: non verranno più mostrate. Se dimentichi la password, il tuo nome utente e una qualsiasi di queste frasi ti permettono di sceglierne una nuova. Ogni frase funziona una sola volta. Tienile per te.",
    list: "Le tue frasi di recupero",
    copyAll: "Copia tutto",
    download: "Scarica .txt",
    savedCheck: "Ho salvato le mie frasi di recupero in un posto sicuro.",
    done: "Fatto",
    fileTitle: "Frasi di recupero Sweet per @{username}",
    fileHow: "Se dimentichi la password, vai su {url}, scegli “{option}” e inserisci il tuo nome utente e una qualsiasi di queste frasi.",
    filePrivate: "Ogni frase funziona una sola volta. Tienile per te: chiunque abbia il tuo nome utente e una di queste frasi può prendere il controllo del tuo account.",
    none: "Il tuo account non ha né email né frasi di recupero. Se dimentichi la password, non potrai più rientrare. Crea subito le frasi di recupero.",
    optional: "Le frasi di recupero ti permettono di scegliere una nuova password senza email. Facoltative finché il tuo account ha un’email.",
    left: "{left} frasi su {total} non usate.",
    leftMade: "{left} frasi su {total} non usate, create il {date}.",
    how: "Ognuna, insieme al tuo nome utente, ti fa scegliere una nuova password una volta. Le hai perse? Creane di nuove e le vecchie smetteranno di funzionare.",
    make: "Crea frasi di recupero",
    makeNew: "Crea nuove frasi",
  },
  account: {
    menu: "Menu dell’account",
    settings: "Impostazioni account",
    profiles: "I tuoi profili",
    logOut: "Esci",
    uploadPhoto: "Carica foto",
    removePhoto: "Rimuovi la foto attuale",
    displayName: "Nome visualizzato",
    showInRankings: "Mostrami nelle classifiche",
    rankingsHelp: "Il tuo nome, la tua foto e le tue statistiche di visione compaiono nelle {link} pubbliche. Disattiva per restarne fuori; il tuo tempo viene comunque contato.",
    save: "Salva",
    emailHelp: "Serve solo per inviarti un link se dimentichi la password. Lascia vuoto per rimuoverla.",
    saveEmail: "Salva email",
    changePassword: "Cambia password",
    deleteWarning: "Questo elimina per sempre il tuo account, i video salvati, le reazioni e i profili seguiti. Non si può annullare.",
    typeToConfirm: "Scrivi {word} per confermare",
    deleteMine: "Elimina il mio account",
  },
  pay: {
    billingPeriod: "Periodo di fatturazione",
    monthly: "Mensile",
    yearly: "Annuale",
    yourPlan: "Il tuo piano",
    month: "mese",
    year: "anno",
    oneMonth: "1 mese",
    months: "{n} mesi",
    oneYear: "1 anno",
    years: "{n} anni",
    perMonth: "{price} al mese",
    save: "Risparmi il {n}%",
    comingSoon: "In arrivo",
    reward: "−{n}% il tuo premio",
    plays: "{n} partite a Sweet Room",
    addedAtOnce: "Accreditate subito",
    get: "Prendi {plan}",
    addMonth: "Aggiungi un mese",
    addYear: "Aggiungi un anno",
    opensSoon: "Pagamenti in arrivo",
    alreadyMember: "Sei già membro?",
    choose: "Scegli come pagare",
    payWith: "Paga con",
    starsInBot: "{n} Stars nel nostro bot Telegram",
    card: "Carta",
    crypto: "Cripto",
    cryptoMore: "BTC, USDT, ETH, TON e oltre 30 altre",
    tooManyStars: "Troppo per un solo pagamento in Telegram Stars.",
    cardMin: "I pagamenti con carta partono da {price}.",
    payStars: "Paga con Telegram Stars",
    preparing: "Preparazione del pagamento…",
    loginFirst: "Prima accedi",
    cantStart: "Impossibile avviare il pagamento",
    noAdsCoins: "Niente pubblicità + {n} Sweet Coins",
    addedOnPay: "Accreditate sul saldo appena paghi",
    payInTelegram: "Paga su Telegram",
    waitingStars: "In attesa del pagamento: questa pagina si aggiorna da sola",
    allSet: "Tutto pronto!",
    noAds: "Niente più pubblicità.",
    noAdsUntil: "Niente pubblicità fino al {date}.",
    coinsAdded: "{n} monete sono sul tuo saldo.",
    startWatching: "Inizia a guardare",
    great: "Ottimo",
    payCard: "Paga con carta",
    failedTitle: "Il pagamento non è andato a buon fine",
    failedBody: "Non è stato addebitato nulla. Puoi riprovare.",
    newTab: "Paga nella nuova scheda",
    newTabBody: "Carta, Apple Pay o Google Pay, sulla pagina sicura di Chain2Pay. Questa pagina si aggiorna da sola a pagamento avvenuto.",
    waiting: "In attesa del pagamento…",
    openAgain: "Riapri la pagina di pagamento",
    somethingWrong: "Qualcosa è andato storto. Riprova tra un minuto.",
    offline: "Sembra che tu sia offline. Riprova tra un minuto.",
    bestValue: "Miglior prezzo",
    coins: "monete",
    orStars: "o {n} Stars",
    packsSoon: "I pacchetti di monete saranno in vendita a breve.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins raccolte!",
    collectedToday: "Raccolte oggi",
    nextBonus: "Prossimo bonus tra",
    collecting: "Raccolta in corso…",
    collect: "Raccogli {n} Sweet Coins",
    alreadyCollected: "Hai già raccolto le monete di oggi. Torna domani.",
    offerLabel: "Sweet Coins e Premium",
    offerTitle: "Prendi le Sweet Coins",
    offerFor: "Per Sweet Room e i video a pagamento",
    premiumFrom: "Premium da {price}",
    upTo: "Niente pubblicità + fino a {n} monete",
    packsFrom: "Pacchetti di monete da {price}",
    collectFree: "Oppure raccogli monete gratis ogni giorno",
    offerButton: "Offerta Sweet Coins",
    guestCollected: "+{n} Sweet Coins! Se non vuoi perdere le tue monete, registrati su Sweet.",
    guestKeep: "Senza un account le monete restano {days} giorni, poi si perdono.",
    guestSignup: "Registrati gratis e tienile",
    guestLogin: "Hai già un account? Accedi",
    guestExpire: "{n} monete andranno perse il {date}.",
    guestUnsaved: "Le tue monete non sono ancora salvate: registrati per tenerle",
    guestExpiring: "{n} delle tue Sweet Coins andranno perse tra meno di un giorno. Registrati gratis per tenerle.",
  },
  footer: {
    copyright: "Copyright",
    takedown: "Rimozione contenuti",
    contact: "Contatti",
    creators: "Creator",
    claim: "Rivendica il profilo",
    webmasters: "Webmaster",
    terms: "Termini",
    privacy: "Privacy",
    info: "Informazioni sul sito",
    telegram: "{site} su Telegram",
  },
  report: {
    heading: "Segnala un video",
    reason: "Motivo",
    takedown: "Copyright / DMCA",
    abuse: "Compaio in questo video senza il mio consenso",
    minor: "Una persona in questo video potrebbe avere meno di 18 anni",
    other: "Altro",
    url: "Link o ID del video",
    email: "La tua email",
    details: "Dettagli",
    detailsPlaceholder: "Cosa dobbiamo rimuovere e perché?",
    send: "Invia segnalazione",
  },
};
